<script>
export const pageName = 'account-payment-history';
export const pageRoute = '/account/payment-history';
export const title = 'Payment history'
export const requireEmailVerified = false;

import { getCurrentUserId } from '../../js/auth.js';
import UserView from '../../../functions/domain/users/userView.js';
import StripeSessionView from '../../../functions/domain/users/stripeSessionView.js';
import { listenForProjections } from '@trullock/firebase-client';

export default {
	data() {
		return { 
			user: null,
			payments: [],
			ready: false
		}
	},
	methods: {
		async boot(opts)
		{
			await listenForProjections([UserView, getCurrentUserId(), StripeSessionView], this.payments, () => {
				this.payments.sort((a, b) => b.createdOn.valueOf() - a.createdOn.valueOf())
			})
			this.ready = true;
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
	<div class="row justify-content-center">
		<div class="col-12 col-md-5 col-xl-4 my-5">
			<h1 class="display-4 text-center mb-3">Payment history</h1>
			<p class="text-muted text-center mb-5">See a record of all your payments to UKRA.</p>
			
			<div v-for="payment in payments" class="card">
				<div v-if="payment.product.type == 'certificate'" class="card-body">
					<h4>{{ payment.product.description }}</h4>
					<p class="small text-muted">{{ payment.createdOn }}</p>
					<p class="mb-0">
						£{{ (payment.product.amount / 100).toFixed(2) }}
						<span v-if="payment.payment_status == 'paid'" class="badge badge-success">Paid</span>
						<span v-if="payment.payment_status == 'unpaid'" class="badge badge-secondary">Unpaid</span>
					</p>
				</div>
				<div v-else-if="payment.product.type == 'membership-card'" class="card-body">
					<h4>{{ payment.product.description }}</h4>
					<p class="small text-muted">{{ payment.createdOn }}</p>
					<p class="mb-0">
						£{{ (payment.product.amount / 100).toFixed(2) }}
						<span v-if="payment.payment_status == 'paid'" class="badge badge-success">Paid</span>
						<span v-if="payment.payment_status == 'unpaid'" class="badge badge-secondary">Unpaid</span>
					</p>
				</div>
				<div v-else-if="payment.product.type == 'membership'" class="card-body">
					<h4>{{ payment.product.description }}</h4>
					<p class="small text-muted">{{ payment.createdOn }}</p>
					<p v-if="payment.product.amount == -1" class="small text-muted"><span class="fe fe-info"></span> Amount not stored for transactions before 2025/04/24</p>
					<p class="mb-0">
						£{{ payment.product.amount > -1 ? (payment.product.amount / 100).toFixed(2) : '??.??' }}
						<span v-if="payment.payment_status == 'paid'" class="badge badge-success">Paid</span>
						<span v-if="payment.payment_status == 'unpaid'" class="badge badge-secondary">Unpaid</span>
					</p>
				</div>
				<div v-else class="card-body">
					{{ payment }}
				</div>
			</div>
			
			<div v-if="payments.length" class="text-center">
				<p class="small text-muted">Note that only payments made through the members portal and made after August 2024 are shown.</p>
			</div>
			<div v-else class="text-center">
				<p>You havent made any payments.</p>
			</div>
		</div>
	</div>
</div>
</template>